import DividerWithText from '../../../../../components/DividerWithText';
import PhotoPickerSummary from '../../../../../components/PhotoPicker/PhotoPickerSummary';
import RowResumeText from '../../../../../components/RowResumeText';
import { MATERIAL_TYPE } from '../Model/Model';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const SummaryStep = ({ t, photoPicker, item, selectedCategory, selectedSubCategory }) => {
    return (
        <div className='row'>
            <DividerWithText title={t('photography')} />
            <div className='mt-4 mb-4'>
                <PhotoPickerSummary photoPicker={photoPicker} classWith={'w-400px'} />
            </div>
            <DividerWithText title={t('general_details')} />
            <div className='d-flex justify-content-center'>
                <div className={'summary-container input-padding-top'}>
                    <div className={'row'}>
                        <div className='col-12 col-md-6 mb-3'>
                            <RowResumeText className='w-100' title={t('name')} value={item?.name} />
                        </div>
                        <div className='col-12 col-md-6 mb-3'>
                            <RowResumeText className='w-100' title={t('code')} value={item?.code} />
                        </div>
                        <div className='col-12 col-md-6 mb-3'>
                            <RowResumeText
                                className='w-100'
                                title={t('category')}
                                value={selectedCategory?.[0]?.label || ''}
                            />
                        </div>
                        <div className='col-12 col-md-6 mb-3'>
                            <RowResumeText
                                className='w-100'
                                title={t('subcategory')}
                                value={selectedSubCategory?.[0]?.label || ''}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <DividerWithText title={t('technical_details')} />
            <div className='d-flex justify-content-center mb-4'>
                <div className={'summary-container input-padding-top'}>
                    <div className={'row'}>
                        <div className='col-12 col-md-6 mb-3'>
                            <RowResumeText className='w-100' title={t('brand')} value={item?.brand} />
                        </div>
                        <div className='col-12 col-md-6 mb-3'>
                            <RowResumeText className='w-100' title={t('model')} value={item?.model} />
                        </div>
                        <div className='col-12 col-md-6 mb-3'>
                            <RowResumeText className='w-100' title={t('serial_number')} value={item?.serialNumber} />
                        </div>
                        <div className='col-12 col-md-6 mb-3'>
                            <RowResumeText
                                className='w-100'
                                title={t('material_type')}
                                value={t(MATERIAL_TYPE[item?.equipmentOwner]?.trans || '')}
                            />
                        </div>
                        <div className='col-12'>
                            <RowResumeText className='w-100' title={t('specification')} value={item?.specification} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SummaryStep;
